export function formatBytes(bytes: number, decimals = 2) {
	if (bytes === 0) return '0 Bytes';

	const k = 1024;
	const dm = decimals < 0 ? 0 : decimals;
	const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

	const i = Math.floor(Math.log(bytes) / Math.log(k));

	return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
}

type HashedArgs = any[] | string;

// eslint-disable-next-line no-var
var HASH: HashedArgs;
export function getHash(): HashedArgs {
	if (HASH) return HASH;
	const hash = window.location.hash.substr(1);
	removeHash();
	const get = () => {
		try {
			return JSON.parse(decodeURI(hash));
		} catch (e) {
			return hash;
		}
	};
	const ret = get();
	HASH = ret;
	return ret;
}

export function buildHash(args: any) {
	/*
const args = [{ tab: 'diario' }, { entity: 'diario', action: 'edit', uniqueId: '92289b1a-da2f-4ba2-092a-08db5207799c' }];
const json = JSON.stringify(args);
const encoded = encodeURI(json);
console.log(encoded);
	*/
	const json = JSON.stringify(args);
	const encoded = encodeURI(json);
	return encoded;
}

export function removeHash() {
	// eslint-disable-next-line no-restricted-globals
	history.pushState('', document.title, window.location.pathname + window.location.search);
}
